import { useState } from 'react'
import { useMutation } from 'react-query';
import AttToken from '../../services/AttToken';
import Empresas from '../../services/Empresas';
import { toast, ToastContainer } from 'react-toastify';
import { Form } from './styles';
import { Button, Stack, TextField } from '@mui/material';
import { useMask } from '@react-input/mask';
import SaveIcon from '@mui/icons-material/Save';
import { empresaType } from '../../context/EmpresasContext';

const empresaService = new Empresas();

export default function CadastrarEmpresas() {
  const [empresaState, setEmpresaState] = useState<empresaType>({
    nome: '',
    cnpj: '',
    emailNotificacao: '',
    status: 'ativo'
  })
  const inputRef = useMask({ mask: '__.___.___/____-__', replacement: '_' });

  const { mutate, isLoading } = useMutation({
    mutationKey: ['PUT_EMPRESA'],
    mutationFn: async () => {
      const token = await AttToken()
      if (token) {
        const empresa: empresaType = {
          nome: empresaState.nome,
          cnpj: empresaState.cnpj,
          emailNotificacao: empresaState.emailNotificacao = '',
          status: empresaState.status
        }
        toast.promise(async () => {
          const response = await empresaService.novaEmpresa(
            token,
            empresa,
          )
          if (!response) throw new Error('Erro ao cadastrar empresa');
          return response
        }, {
          pending: 'Cadastrando empresa',
          success: 'Empresa cadastrada',
          error: 'Erro cadastrar empresa'
        })
      }
    },
    onSuccess: () => setEmpresaState({
      nome: '',
      cnpj: '',
      emailNotificacao: '',
      status: 'ativo'
    })
  })

  return (
    <>
      <ToastContainer />
      <Form onSubmit={(event) => {
        event.preventDefault()
        mutate()
      }}>
        <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1.5} width='100%'>
          <TextField
            fullWidth
            label='Nome'
            value={empresaState.nome}
            onChange={(event: any) => setEmpresaState({ ...empresaState, nome: event.target.value })} />
          <TextField
            fullWidth
            inputRef={inputRef}
            label='CNPJ'
            value={empresaState.cnpj}
            onChange={(event: any) => setEmpresaState({ ...empresaState, cnpj: event.target.value })} />
          <Button
            variant='contained'
            endIcon={<SaveIcon />}
            disabled={
              (empresaState.nome?.length <= 0
                || empresaState.cnpj?.length < 18)
              || isLoading
            }
            color='success'
            type='submit'>
            Salvar
          </Button>
        </Stack>
      </Form>
    </>
  )
}